export const verticalMenuMetaData = {
    isRepeatable: false
}
